import store from './store';

const request = axios.create();

request.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('token');
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  config.params = { ...{}, ...config.params, ...{ lang: store.getters['auth/user'].locale || 'th' } };
  return config;
});

request.interceptors.response.use((response) => response, (error) => {
  // Your Interceptor code to do something with response error
  // Return error
  if (error.response.status === 401) {
    // if you ever get an unauthorized, logout the user
    store.dispatch('auth/logout');
    // you can also redirect to /login if needed !
  }
  return Promise.reject(error);
});

export default request;
